import {
  Crown,
  FilePlus2,
  History,
  LogOut,
  Scale,
  SlidersHorizontal,
  UserRoundCog,
} from "lucide-react";
import { Link, useNavigate } from "react-router-dom";

export default function AppHeader({ onNewRound, isPro = false, isOwner = false }) {
  const navigate = useNavigate();
  const logout = async () => {
    await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/auth/logout`, {
      method: "POST",
      credentials: "include",
    });
    Object.keys(sessionStorage)
      .filter((key) => key.startsWith("pfjudgepro-active-ballot-"))
      .forEach((key) => sessionStorage.removeItem(key));
    navigate("/login");
  };
  return (
    <header className="app-header" data-testid="app-header">
      <Link className="brand" to="/" data-testid="brand-home-link">
        <span className="brand-mark">
          <Scale size={18} />
        </span>
        <span>PFJudgePro</span>
      </Link>
      <div className="header-actions">
        <button
          className="icon-action"
          onClick={onNewRound}
          data-testid="new-round-button"
          title="Start a new ballot"
        >
          <FilePlus2 size={18} />
          <span>New round</span>
        </button>
        <Link
          className="pro-link"
          to="/pro"
          data-testid={isPro ? "pro-access-link" : "upgrade-to-pro-link"}
        >
          <Crown size={17} />
          <span>{isPro ? "PRO Access" : "Explore Pro"}</span>
        </Link>
        {isPro && (
          <Link
            className="icon-action"
            to="/history"
            data-testid="round-history-link"
            title="Round history"
          >
            <History size={17} />
          </Link>
        )}
        {isOwner && (
          <Link
            className="icon-action"
            to="/owner-dashboard"
            data-testid="owner-dashboard-link"
            title="Pilot invitations"
          >
            <UserRoundCog size={17} />
          </Link>
        )}
        {isPro && (
          <Link
            className="icon-action"
            to="/settings"
            data-testid="pro-settings-link"
            title="Pro settings"
          >
            <SlidersHorizontal size={17} />
          </Link>
        )}
        <button
          className="logout-action"
          onClick={logout}
          data-testid="logout-button"
          title="Sign out"
        >
          <LogOut size={17} />
        </button>
      </div>
    </header>
  );
}
